(function(root){
'use strict';
const pair=(a,b)=>[a,b].sort().join('|');
function defaults(){
 const row=(item,use)=>({item,use,enabled:true});
 return [
 {id:'base',name:'Basisforbruk',enabled:true,rows:[row(1,24),row(2,24),row(10,24)]},
 {id:'morning',name:'En rolig morgen',enabled:true,rows:[row(0,1),row(6,.15),row(5,.05)]},
 {id:'cooking',name:'Lage mat',enabled:true,rows:[row(0,1),row(7,.5),row(3,.1),row(5,.05)]},
 {id:'evening',name:'Kveld på hytta',enabled:true,rows:[row(0,3),row(8,3),row(9,2)]},
 {id:'washing',name:'Vask og rengjøring',enabled:true,rows:[row(4,.5),row(13,.2),row(5,.05)]},
 {id:'heating',name:'Oppvarming',enabled:false,rows:[row(12,6)]}
 ];
}
function defaultOverlap(){return ['morning','cooking','evening','washing'].map(id=>pair(id,'heating'));}
// Legacy split allocations become one membership, retaining their daily use.
function uniqueMembership(scenarios){
 const found=new Map();
 scenarios.forEach(s=>s.rows.forEach(r=>{if(!found.has(r.item))found.set(r.item,[]);found.get(r.item).push({s,r});}));
 for(const [item,entries] of found){
  if(entries.length<2)continue;
  const base=entries.find(e=>e.s.id==='base');
  const owner=base?.s||scenarios.find(s=>s.id==='base')||entries[0].s;
  const enabled=entries.filter(e=>e.r.enabled&&(e.s.enabled||e.s.id==='base'));
  const use=base?base.r.use:entries.filter(e=>e.r.enabled).reduce((n,e)=>n+e.r.use,0);
  scenarios.forEach(s=>s.rows=s.rows.filter(r=>r.item!==item));
  owner.rows.push({item,use:Math.round(use*1e6)/1e6,enabled:!!enabled.length});
 }
 return scenarios;
}
function assign(scenarios,item,target,fallbackUse){
 const entries=scenarios.flatMap(s=>s.rows.filter(r=>r.item===item));
 const use=entries.length?entries.reduce((n,r)=>n+r.use,0):fallbackUse;
 scenarios.forEach(s=>s.rows=s.rows.filter(r=>r.item!==item));
 if(target){const s=scenarios.find(s=>s.id===target);if(s)s.rows.push({item,use,enabled:true});}
}
const periods=[['morning','Morgen'],['lunch','Formiddag'],['afternoon','Ettermiddag'],['evening','Kveld'],['night','Natt']];
const periodDefaults={base:periods.map(p=>p[0]),morning:['morning'],cooking:['lunch','evening'],evening:['evening'],washing:['afternoon'],heating:periods.map(p=>p[0])};
const names={base:'Basis – alltid tilgjengelig',morning:'Frokost og kaffe',cooking:'Matlaging',evening:'Lys og hygge',washing:'Stell og rengjøring',heating:'Varme og varmtvann'};
function schedule(scenarios){
 uniqueMembership(scenarios);
 for(const s of scenarios){s.name=names[s.id]||s.name;if(!Array.isArray(s.periods))s.periods=[...periodDefaults[s.id]];if(s.id==='base')s.periods=periods.map(p=>p[0]);}
 return scenarios;
}
// Example household, not product specifications. New equipment is optional.
function household(catalog){
 const extras=[
 ['Vannkoker',2000,0.1,'morning'],['Brødrister',800,0.1,'morning'],
 ['Kokeplate',2000,0.5,'cooking'],['Hårføner',1600,0.1,'washing'],
 ['Bærbar PC',60,2,'evening'],['Radio / høyttaler',15,3,'evening'],
 ['Varmtvannsbereder',1500,2,'heating'],['Baderomsvifte',20,1,'washing'],['Airfryer',1300,0.5,'cooking']
 ];
 const groups=schedule(defaults());
 const rows={base:[[1,24],[2,24],[10,24],[5,.15]],morning:[[6,.15]],cooking:[[7,.5],[3,.1],[11,.5,false]],evening:[[0,5],[8,3],[9,2]],washing:[[4,.5],[13,.2]],heating:[[12,6]]};
 const times={base:periods.map(p=>p[0]),morning:['morning','lunch'],cooking:['afternoon'],evening:['evening'],washing:['lunch'],heating:['morning','evening']};
 groups.forEach(g=>{g.rows=rows[g.id].map(([item,use,enabled=true])=>({item,use,enabled}));g.periods=times[g.id];});
 extras.forEach(([name,watts,hours,group])=>{const item=catalog.length;catalog.push({name,watts,hours,count:1,duty:100,custom:true,enabled:false,note:'Eksempelverdi – tilpass til apparatet og bruken din.'});groups.find(g=>g.id===group).rows.push({item,use:hours,enabled:false});});
 return groups;
}
function compileSchedule(catalog,scenarios){
 const errors=[],seen=new Set(),active=scenarios.filter(s=>s.id==='base'||s.enabled);
 const linesFor=(s,period=null)=>s.rows.filter(r=>r.enabled&&r.use>0).map(r=>{
 const x=catalog[r.item];if(!x){errors.push('Ukjent apparat.');return null;}
 const slots=s.id==='base'?periods.map(p=>p[0]):s.periods||[];
 const included=slots.filter(id=>!r.excludedPeriods?.includes(id));
 if(period&&!included.includes(period)||!included.length)return null;
 const use=r.use*(period?1:included.length)/slots.length;
 return {...x,item:r.item,enabled:true,duringCharge:true,simultaneous:true,hours:x.cycleKwh!=null?x.hours:use,cycles:x.cycleKwh!=null?use:x.cycles,kwh:x.cycleKwh!=null?x.cycleKwh*use*x.count:x.watts*x.count*use*x.duty/100/1000};}).filter(Boolean);
 scenarios.forEach(s=>s.rows.forEach(r=>{if(seen.has(r.item))errors.push('Et apparat tilhører flere forbrukspakker.');seen.add(r.item);}));
 active.forEach(s=>{if(!s.periods?.length&&s.rows.some(r=>r.enabled&&r.use>0))errors.push('Velg tidspunkt for '+s.name+'.');});
 const dailyItems=active.flatMap(s=>linesFor(s));
 dailyItems.forEach(x=>{if(x.cycleKwh==null&&x.hours>24)errors.push(x.name+': mer enn 24 timer per døgn.');});
 const groups=periods.map(([id,name])=>{const included=active.filter(s=>s.id==='base'||s.periods?.includes(id));const lines=included.flatMap(s=>linesFor(s,id));return {id,name,ids:included.filter(s=>s.id!=='base').map(s=>s.id),lines,peak:lines.reduce((n,x)=>n+x.watts*x.count/1000,0)};});
 const summaries=scenarios.map(s=>{const lines=linesFor(s);return {id:s.id,names:lines.map(x=>x.name),kwh:lines.reduce((n,x)=>n+x.kwh,0)};});
 return {errors,dailyItems,groups,summaries,worst:groups.reduce((a,b)=>b.peak>a.peak?b:a,groups[0])};
}
function periodBreakdown(catalog,scenarios){
 const result=compileSchedule(catalog,scenarios),total=result.dailyItems.reduce((n,x)=>n+x.kwh,0);
 if(result.errors.length||!Number.isFinite(total)||result.groups.some(g=>!Number.isFinite(g.peak)))return [];
 return result.groups.map(g=>{const kwh=g.lines.reduce((n,x)=>n+x.kwh,0);return {id:g.id,name:g.name,peak:g.peak,kwh,share:total>0?100*kwh/total:0};});
}
function compile(catalog,scenarios,overlaps){
 if(scenarios.every(s=>Array.isArray(s.periods)))return compileSchedule(catalog,scenarios);
 const errors=[];
 const base=scenarios.find(s=>s.id==='base');
 const baseIds=new Set(base.rows.filter(r=>r.enabled&&r.use>0).map(r=>r.item));
 const active=scenarios.filter(s=>s.id==='base'||s.enabled);
 const rowsFor=s=>s.rows.filter(r=>r.enabled&&r.use>0&&(s.id==='base'||!baseIds.has(r.item)));
 const add=(map,row)=>{const x=catalog[row.item];if(!x)return;const old=map.get(row.item);map.set(row.item,(old||0)+row.use);};
 const makeLines=map=>[...map].map(([i,use])=>{const x=catalog[i];return {...x,enabled:true,duringCharge:true,simultaneous:true,hours:x.cycleKwh!=null?x.hours:use,cycles:x.cycleKwh!=null?use:x.cycles,kwh:x.cycleKwh!=null?x.cycleKwh*use*x.count:x.watts*x.count*use*x.duty/100/1000};});
 const total=new Map();active.forEach(s=>rowsFor(s).forEach(r=>add(total,r)));
 for(const [i,use] of total){if(catalog[i].cycleKwh==null&&use>24+1e-9)errors.push(catalog[i].name+': mer enn 24 timer samlet bruk per døgn.');}
 const dailyItems=makeLines(total);
 const choices=active.filter(s=>s.id!=='base');
 const allowed=new Set(overlaps);
 const groups=[];
 for(let mask=0;mask<(1<<choices.length);mask++){
  const selected=choices.filter((_,i)=>mask&(1<<i));
  if(selected.some((a,i)=>selected.slice(i+1).some(b=>!allowed.has(pair(a.id,b.id)))))continue;
  const map=new Map();rowsFor(base).forEach(r=>add(map,r));selected.forEach(s=>rowsFor(s).forEach(r=>add(map,r)));
  const lines=makeLines(map),peak=lines.reduce((n,x)=>n+(x.kwh>0?x.watts*x.count/1000:0),0);
  groups.push({name:selected.length?selected.map(s=>s.name).join(' + '):base.name,lines,peak,ids:selected.map(s=>s.id)});
 }
 const worst=groups.reduce((a,b)=>b.peak>a.peak?b:a,groups[0]);
 const summaries=scenarios.map(s=>{const map=new Map();rowsFor(s).forEach(r=>add(map,r));const lines=makeLines(map);return {id:s.id,kwh:lines.reduce((n,x)=>n+x.kwh,0),names:lines.map(x=>x.name)};});
 return {dailyItems,groups,worst,summaries,errors};
}
if(typeof module!=='undefined')module.exports={defaults,defaultOverlap,pair,compile,uniqueMembership,assign,schedule,periods,periodBreakdown,household};else root.UsageScenarios={defaults,defaultOverlap,pair,compile,uniqueMembership,assign,schedule,periods,periodBreakdown,household};
})(typeof window==='undefined'?{}:window);
